import { Ball, Misc, OvalShading, Player, RectangleShading, TextBox, TrapezoidShading } from "../marker";

export enum BasketballMiscType {
  HOOP = "HOOP",
  BALL_STATIC = "BALL_STATIC",
  FLAG = "FLAG",
  CONE = "CONE",
}

export type BasketballMiscMarker = Misc<BasketballMiscType>;

export type BasketballMarker =
  | Player
  | Ball
  | TextBox
  | BasketballMiscMarker
  | RectangleShading
  | OvalShading
  | TrapezoidShading;
